import _ from 'lodash';

const EnvironmentMixin = {
  methods: {
    getOs(os) {
      return `${process.env.BASE_URL}img/environments/os/${os}.png`;
    },
    getBrowser(browser) {
      return `${process.env.BASE_URL}img/environments/browser/${browser}.png`;
    },
    availableEnvironments(used) {
      // const allEnvironments = [
      //   {os: 'windows', browser: 'chrome'},
      //   {os: 'windows', browser: 'firefox'},
      //   {os: 'windows', browser: 'ie'},
      //   {os: 'linux', browser: 'chrome'},
      //   {os: 'linux', browser: 'firefox'},
      //   {os: 'mac', browser: 'chrome'},
      //   {os: 'mac', browser: 'firefox'},
      //   {os: 'mac', browser: 'safari'}
      // ];

      // TODO: bulbprep
      const allEnvironments = [
        {os: 'linux', browser: 'chrome'}
      ];

      if (!used) return allEnvironments;
      return _.filter(allEnvironments,
        (e) => !_.find(used, e,
          (t) => t.os === e.os && t.browser === e.browser));
    },
    availableBrowsers(used) {
      let allEnvironments = [
        {os: 'linux', browser: 'chrome', text: 'Chrome'},
        {os: 'linux', browser: 'firefox', text: 'Firefox'}
      ];
      if (this.user && this.user.superAdmin) {
        allEnvironments = [
          {os: 'windows', browser: 'ie', text: 'Internet Explorer'},
          {os: 'windows', browser: 'edge', text: 'Edge'},
          {os: 'linux', browser: 'chrome', text: 'Chrome'},
          {os: 'linux', browser: 'firefox', text: 'Firefox'},
          {os: 'mac', browser: 'safari', text: 'Safari'}
        ];
      }
      if (!used) return allEnvironments;
      return _.filter(allEnvironments,
        (e) => !_.find(used, e,
          (t) => t.os === e.os && t.browser === e.browser));
    }
  },
  data() {
    return {
      allEnvironments: [
        {os: 'windows', browser: 'ie', text: 'Internet Explorer'},
        {os: 'windows', browser: 'edge', text: 'Edge'},
        {os: 'linux', browser: 'chrome', text: 'Chrome'},
        {os: 'linux', browser: 'firefox', text: 'Firefox'},
        {os: 'mac', browser: 'safari', text: 'Safari'}
      ]
    };
  }
};
export default EnvironmentMixin;
